const getCurrentUserEmail = ({ account, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (account && account.Email) {
    return account.Email;
  }

  return '';
};

export default getCurrentUserEmail;



// WEBPACK FOOTER //
// ./src/utils/print/getCurrentUserEmail.js